import apiHelper, {LONG_REQUEST_TIMEOUT_MS} from '../helpers/apiHelper'

export default {
  get()
  {
    return apiHelper.request('investments')
  },
  getInvestmentsPage(page, filters, searchPhrase)
  {
    if (filters || searchPhrase)
    {
      const data = {filters: filters}
      data.search = searchPhrase
      return apiHelper.request('investments/' + parseInt(page), data, 'POST')
    }
    return apiHelper.request('investments/?page=' + parseInt(page))
  },
  sendInvestment(data)
  {
    return apiHelper.request('investments', data, 'POST')
  },
  sendExcelRequest(page, filters, searchPhrase)
  {
    const data = {}
    data.page = parseInt(page)
    if (filters || searchPhrase)
    {
      data.filters = filters
      data.search = searchPhrase
    }
    return apiHelper.request('investments/export.xlsx', data, 'POST', {}, false, {timeout: LONG_REQUEST_TIMEOUT_MS})
  }
}
